import * as _ from 'lodash/fp';
import { Point } from '../types/point';
import { calculateBoundingRect, ItemPositionProperties } from './size-and-position.utils';

export const getItemsBoundaryRect = (items: ItemPositionProperties[]) => {
  const boundingRects = items.map((s) => calculateBoundingRect(s));

  const left = _.min(boundingRects.map((p) => p.x)) || 0;
  const top = _.min(boundingRects.map((p) => p.y)) || 0;
  const right = _.max(boundingRects.map((p) => p.x + p.width)) || 0;
  const bottom = _.max(boundingRects.map((p) => p.y + p.height)) || 0;

  return {
    x: left,
    y: top,
    width: right - left,
    height: bottom - top,
  };
};

export const getPathBoundaries = (path: Point[]): { xMin: number; xMax: number; yMin: number; yMax: number } => {
  const result: { xMin?: number; xMax?: number; yMin?: number; yMax?: number } = {};

  path.map((point) => {
    result.xMin = result.xMin ? Math.min(result.xMin, point.x) : point.x;
    result.xMax = result.xMax ? Math.max(result.xMax, point.x) : point.x;
    result.yMin = result.yMin ? Math.min(result.yMin, point.y) : point.y;
    result.yMax = result.yMax ? Math.max(result.yMax, point.y) : point.y;
  });

  return result as { xMin: number; xMax: number; yMin: number; yMax: number };
};
